
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenDesk as ObiScreenDeskElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-desk.js';
 
 
 

 
 export const ObiScreenDesk = createComponent({
   react: React,
   tagName: 'obi-screen-desk',
   elementClass: ObiScreenDeskElement,
   events: {
     
   }
  });
 
 